import { Color, Emotion, Message } from "../Message";
import { Robot } from "../Robot";
import { generateId } from "@/helpers/utils";

export class DebugRobot implements Robot {
  id: string;
  kind = "DebugRobot";
  isOn: boolean;
  messageLog: string[];
  errors = [];

  constructor(messages: string[] = []) {
    this.id = "debug" + generateId();
    this.isOn = true;
    console.debug("Debug robot constructed");
    this.messageLog = messages;
  }

  sendMessage(message: Message): void {
    console.debug("Robot sending message...");
    this.messageLog = [...this.messageLog, message.speech];
  }

  sendSpeech(speech: string): void {
    console.debug(speech);
    this.messageLog = [...this.messageLog, speech];
  }

  sendEmotion(emotion: Emotion): void {
    console.debug("Attempting to send emotion...");
    console.debug(emotion);
  }

  sendColor(color: Color): void {
    console.debug("Attempting to send color...");
    console.debug(color);
  }

  toString(): string {
    return JSON.stringify({
      kind: this.kind,
      messages: this.messageLog,
    });
  }

  toPrettyString(): string {
    return `DebugBot with ${this.messageLog.length} messages`;
  }
}
